// extracted by mini-css-extract-plugin
module.exports = {"footer":"CheckoutOutOfStockFormFooter_footer___Jnu1"};